import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  Button,
  Flex,
  Select,
  titleCase,
  useDialogContext,
} from '@components/primitives';

import { UserObject } from '@api/types';
import { getRole } from '@components/features/Restricted/registry';

import { useUpdateUserRole } from './queries';

const globalRoles = [getRole('user'), getRole('support'), getRole('superuser')];

export const UserRoleUpdateModal = ({
  userToChange,
}: {
  userToChange: UserObject;
}) => {
  const [selectedRole, setSelectedRole] = useState(userToChange.roleName);
  const updateUserMutation = useUpdateUserRole();
  const dialog = useDialogContext();

  const handleSubmit = () => {
    updateUserMutation.mutate(
      {
        userId: userToChange.id,
        newRoleName: selectedRole,
      },
      {
        onSuccess: () => {
          const role = globalRoles.find((role) => role.key === selectedRole);
          const roleLabel = titleCase(role?.label ?? 'user');
          toast.success(`Role changed to ${roleLabel}`);
          dialog.close();
        },

        onError: () => {
          toast.error(`Failed to update role`);
        },
      }
    );
  };

  return (
    <Flex gap="12px" direction="column">
      <Flex.Item>
        <Select value={selectedRole} onChange={setSelectedRole}>
          {globalRoles.map((role) => (
            <Select.Option key={role.key} value={role.key}>
              {titleCase(role.label)}
            </Select.Option>
          ))}
        </Select>
      </Flex.Item>
      <Flex.Item>
        <Button variant="danger-strong" onClick={handleSubmit}>
          Change user role
        </Button>
      </Flex.Item>
    </Flex>
  );
};
